// extracted by mini-css-extract-plugin
module.exports = {"content":"Collapsable_content__8nZor","button":"Collapsable_button__PUt6b","active":"Collapsable_active__ilET0"};